// src/pages/Company.jsx
import React from 'react';
import WhoWeAre from '../components/Company/WhoWeAre';
import PreFooter from '../components/PreFooter';
import Team from '../components/Company/Team';
import Footer from '../components/Footer';
import '../styles/components/_section.scss';


const CompanyPage = () => (
  <div className="company-page">
    <WhoWeAre/>
    <Team />
    <PreFooter/>
    <Footer />
  </div>
);

export default CompanyPage;
